@use '@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss';

.container {
  padding: 0 var(--hcr-spacing-4);
}

.highlightedRow td,
.highlightedRow th {
  background-color: var(--hcr-bg-secondary-color);
}

.table table {
  width: 100%;
  table-layout: fixed;
}

.labelCol,
.totalCol {
  width: 120px;
}

.labelCell {
  white-space: nowrap;
}

.rowLabel {
  display: inline-flex;
  align-items: center;
  gap: var(--hcr-spacing-1);
  font-weight: 700;
}

.infoIcon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--hcr-content-primary-color);
}
